import { IIncidentReportFormData } from './components/modal/IncidentReportModal'

// API payload type - incidentDate is converted to Date before sending to API
type IIncidentReportPayload = Omit<IIncidentReportFormData, 'incidentDate'> & {
  incidentDate: Date | null
}

// Helper to extract relation ObjectIds and data from form data
function extractIncidentReportPayload(incidentReport: IIncidentReportPayload) {
  const {
    technicianObjectId,
    orderObjectId,
    vanObjectId,
    installationPointObjectId,
    coachObjectId,
    ...incidentReportData
  } = incidentReport

  return {
    incidentReportData,
    orderObjectId,
    technicianObjectId,
    vanObjectId,
    installationPointObjectId,
    coachObjectId,
  }
}

export function getIncidentReports(params: {
  offSet: number
  pageSize: number
  columnFilters: string
  sortBy?: string
}) {
  const { offSet, pageSize, columnFilters, sortBy } = params
  const url = new URL(`${process.env.REACT_APP_ORIGIN}/incident-reports`)
  url.searchParams.append('offSet', offSet.toString())
  url.searchParams.append('pageSize', pageSize.toString())
  url.searchParams.append('columnFilters', columnFilters)
  if (sortBy) {
    url.searchParams.append('sortBy', sortBy)
  }

  return {
    url: url.toString(),
    method: 'GET',
  }
}

export function getIncidentReportByObjectId(objectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/${objectId}`,
  }
}

export function getIncidentReportsByOrderObjectId(orderObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/order/${orderObjectId}`,
  }
}

export function createIncidentReport(incidentReport: IIncidentReportPayload) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports`,
    body: extractIncidentReportPayload(incidentReport),
  }
}

export function updateIncidentReport(incidentReport: IIncidentReportPayload) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports`,
    body: extractIncidentReportPayload(incidentReport),
  }
}

export function getTechnicianAssignedToOrder(orderObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/order/${orderObjectId}`,
  }
}

export function getCoachUsers(permissionName: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/users/permission?permissionName=${permissionName}`,
  }
}

export function getActiveTechnicians() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians?pageSize=1000&offSet=0&columnFilters=${encodeURIComponent(JSON.stringify({ inactive: false }))}`,
  }
}

export function getOrderImages(orderVehicleObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/images/installation/${orderVehicleObjectId}`,
  }
}

export function getOrderImagesAsBase64(orderVehicleObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/images/installation/${orderVehicleObjectId}/base64`,
  }
}

export function uploadIncidentReportImage(
  incidentReportObjectId: string,
  file: FormData,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/${incidentReportObjectId}/images`,
    body: file,
  }
}

export function getIncidentReportImages(incidentReportObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/${incidentReportObjectId}/images`,
  }
}

export function getIncidentReportImagesAsBase64(incidentReportObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/${incidentReportObjectId}/images/base64`,
  }
}

export function deleteIncidentReportImage(imageObjectId: string) {
  return {
    method: 'DELETE',
    url: `${process.env.REACT_APP_ORIGIN}/incident-reports/images/${imageObjectId}`,
  }
}

